import React from 'react';
import PropTypes from 'prop-types';

import classes from './ThreeOptionsSelector.css';

const threeOptionsSelector = props => {
  const {
    selectedOption,
    option1,
    option2,
    option3,
    selectedOption1,
    selectedOption2,
    selectedOption3
  } = props;

  return (
    <div className={classes.ThreeOptionsSelector}>
      <div className={classes.SelectorWrapper}>
        <div
          className={selectedOption === option1 ? classes.Active : null}
          onClick={selectedOption1}
        >
          <h4>{option1}</h4>
        </div>
        <div
          className={selectedOption === option2 ? classes.Active : null}
          onClick={selectedOption2}
        >
          <h4>{option2}</h4>
        </div>
        <div
          className={selectedOption === option3 ? classes.Active : null}
          onClick={selectedOption3}
        >
          <h4>{option3}</h4>
        </div>
      </div>
    </div>
  );
};

threeOptionsSelector.propTypes = {
  selectedOption: PropTypes.string.isRequired,
  option1: PropTypes.string.isRequired,
  option2: PropTypes.string.isRequired,
  option3: PropTypes.string.isRequired,
  selectedOption1: PropTypes.func,
  selectedOption2: PropTypes.func,
  selectedOption3: PropTypes.func,
};


export default threeOptionsSelector;
